import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
    ];
};
